import { Popover } from "@headlessui/react";
import { Fragment } from "react";
import { NavLink, useLocation } from "react-router-dom";
import classNames from 'classnames';
import LogoSmall from "../Logo/LogoSmall";
import MobileMenuButton from "../buttons/MobileMenuButton";
import ProfileMenu from "./ProfileMenu";
import MobileMenu from "./MobileMenu";
import AccountSelector from "./AccountSelector";
import { Menu } from "antd";

const useActiveMenuItem = () => {
  const location = useLocation();
  const routes = {
    '/': '/',
    '/campaigns': '/campaigns',
    '/create/campaign': '/create/campaign',
    '/create/campaign/select-websites': '/create/campaign',
    '/create/campaign/create-meta-article': '/create/campaign',
    '/create/display-campaign/select-websites': '/create/display-campaign',

  }
  return routes[location.pathname] || location.pathname
};
const TopNavigation = ({ user, userNavigation, navigation }) => {
  const activeMenuItem = useActiveMenuItem()
  
  const items = navigation.map(({name, Icon, children = [], ...props}) => ({
    key: props.to,
    children: children.map((child) => ({
      key: child.to,
      label: (<NavLink to={child.to} className="flex items-center">
        {child.name}

      </NavLink>
  ),
    })),
    label: (<NavLink to={props.to} className="flex items-center">
       <Icon className='h-6 w-6 mr-3 text-gray-400 group-hover:text-gray-500'/>  
       <span className="truncate">{name}</span>
    
      </NavLink>
      )
  })
)
  const handleNavigation = (e) => {
    console.log(e.key, e)
  }
  return (
    <Popover
      as="header"
      className={({ open }) =>
        classNames(
          open ? "fixed inset-0 z-40 overflow-y-auto" : "",
          "bg-white shadow-sm lg:static lg:overflow-y-visible"
        )
      }
    >
      {({ open }) => (
        <Fragment>
          <div className="max-w-7xl mx-auto sm:px-6 lg:px-8">
            <div className="relative flex justify-between">
              <LogoSmall />
              <Menu
                className="flex-grow flex xl:col-span-6 invisible lg:visible"
                mode='horizontal'
                selectedKeys={[activeMenuItem]}
                items={items}
                onClick={handleNavigation}
              />

              <MobileMenuButton open={open} />
              <div className="hidden lg:flex lg:items-center lg:justify-end xl:col-span-4">
                {/*<Bell />*/} {/* Profile dropdown */}
                <AccountSelector />
                <ProfileMenu
                  user={user}
                  userNavigation={userNavigation}
                />
              </div>
            </div>
          </div>
          <MobileMenu
            user={user}
            userNavigation={userNavigation}
            navigation={navigation}
          />
        </Fragment>
      )}
    </Popover>
  );
};

export default TopNavigation;
